<template>
  <div class="home">
    <!-- MB tracking code -->
    <img
      style="width:1px; height:1px;"
      :src="'https://servedby.flashtalking.com/imp/2/112659;4041199;201;pixel;Forbes;ForbesROSlistasponsorship/?cachebuster='+timecurr()"
    />
    <!-- MB tracking code -->
    <img
      class="bglines"
      src="../assets/bgpattern.png"
    >
    <div class="inner">
      <div class="logo">
        <a href="https://forbes.hu"> <img
            class="forbeslogo"
            src="../assets/forbes-yellow.svg"
            alt="Forbes"
          ></a>
      </div>
      <h1>A legnagyobb magyar családi vállalkozások listája</h1>
      <p class="intro">Az államkapitalizmus átrajzolta a lista élmezőnyét, de még mindig igaz,
        hogy a legnagyobb családi vállalkozások időtálló, stabil cégóriásokká nőttek az
        elmúlt 30 évben. Termékeikkel, szolgáltatásaikkal nap mint nap találkozunk.</p>
      <p class="credits">Összeállította: Zsiborás Gergő, Bánáti Anna, Sándor Krisztián<br>
        Közreműködött: Csepregi Dániel</p>
      <div
        class="next"
        v-hammer:pan.horizontal="panHandlerhorizontal"
        v-hammer:panend="onPanEnd"
      >
        <router-link to="lista"><img
            class="right"
            src="../assets/right-double.svg"
            alt=">"
          ></router-link>
      </div>
      <div class="modszertanopener">
        Módszertan
        <img src="../assets/next-sub.svg">
      </div>
      <div class="modszertan">
        <p>Családinak vettük azokat a cégeket, ahol a tulajdonosi körben,
          illetve a vezető menedzsmenttagok között vérségi rokonság áll fenn
          (tehát a házastársak által tulajdonolt cégeket, ha más rokon nem tagja
          a menedzsmentnek, nem vettük számításba). A társaságokat az amerikai
          Forbes módszertanát alapul véve értékeltük. Ahol lehetett,
          EBITDA-alapon számoltunk, leginkább ez alkalmas arra, hogy megmutassa
          a cégek pénztermelő képességét. Iparági szorzókat használtunk, majd az
          így kapott értékből levontuk a vállalat kötelezettségeit, és hozzáadtuk
          a készpénzállományát.</p>
        <p>Valamennyi esetben publikusan elérhető információkból dolgoztunk,
          ahol lehetett, konszolidált adatokat használtunk, ahol ilyen nem állt
          rendelkezésre, magunk konszolidáltuk az eredményeket az elérhető információk alapján.
          A Bisnode PartnerControl gyűjtései segítették a munkánkat, a cégértékelésben a Concorde MB
          Partners munkatársai adtak tanácsot.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { VueHammer } from 'vue2-hammer';

Vue.use(VueHammer);

VueHammer.config.pan = {
  direction: 6,
};

export default {
  name: 'home',
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
    onPanEnd(e) {
      if (e.distance > 50) {
        this.$router.push({ name: 'Lista' });
      }
    },
    panHandlerhorizontal(e) {
      if (e.offsetDirection === 4) {
        document.querySelector('.next a').style.transform = `translateX(${e.distance}px)`;
      }
      if (e.offsetDirection === 2) {
        document.querySelector('.next a').style.transform = `translateX(-${e.distance}px)`;
      }
    },
    modszertan() {
      const opener = document.querySelector('.modszertanopener');
      const modszertan = document.querySelector('.modszertan');

      opener.addEventListener('click', () => {
        modszertan.classList.toggle('show');
        opener.classList.toggle('show');
        if (modszertan.classList.contains('show')) {
          modszertan.scrollIntoView();
        }
      });
      modszertan.addEventListener('click', () => {
        modszertan.classList.remove('show');
        opener.classList.remove('show');
      });
    },
    timecurr() {
      const time = new Date();
      return `${time.getFullYear()}${time.getMonth()}${time.getDate()}${time.getHours()}${time.getMinutes()}${time.getSeconds()}`;
    },
  },
  mounted() {
    this.modszertan();
  },
};
</script>
<style scoped lang="css">
h1 {
  text-transform: uppercase;
  font-size: 30px;
  font-family: "Cardo", serif;
  text-align: center;
  width: 310px;
}
.forbeslogo {
  height: 21px;
}
.inner {
  display: grid;
  grid-template-columns: 1fr 650px 1fr;
  grid-template-rows: auto auto auto auto auto auto;
  display: -ms-grid;
  -ms-grid-columns: 1fr 650px 1fr;
  -ms-grid-rows: auto auto auto auto auto auto;
  align-items: center;
  justify-content: center;
  justify-items: center;
  padding-top: 4vw;
}
.logo {
  grid-column: 2/3;
  grid-row: 1/2;
  -ms-grid-column: 2;
  -ms-grid-row: 1;
  text-align: center;
}
.logo a {
  display: block;
}
h1 {
  grid-column: 2/3;
  grid-row: 2/3;
  -ms-grid-column: 2;
  -ms-grid-row: 2;
  -ms-grid-column-align: center;
}
.intro {
  grid-column: 2/3;
  grid-row: 3/4;
  -ms-grid-column: 2;
  -ms-grid-row: 4;
  text-transform: uppercase;
  -ms-grid-column-align: center;
}
.credits {
  grid-column: 2/3;
  grid-row: 4/5;
  -ms-grid-column: 2;
  -ms-grid-row: 5;
  font-weight: 300;
  -ms-grid-column-align: center;
}
.next {
  grid-column: 3/4;
  grid-row: 1/7;
  -ms-grid-column: 3;
  -ms-grid-row-span: 4;
  -ms-grid-column-align: center;
  -ms-grid-row-align: center;
}
.next a {
  display: block;
}
.intro,
.credits {
  font-size: 13px;
  text-align: center;
  letter-spacing: 2px;
  line-height: 2;
}
.modszertanopener {
  grid-column: 2/3;
  grid-row: 5/6;
  -ms-grid-column: 2;
  -ms-grid-row: 6;
  -ms-grid-column-align: center;
  cursor: pointer;
}
.modszertanopener img {
  width: 20px;
  transition: all 1s;
}
.modszertanopener.show img {
  transform: rotate(180deg);
}
.modszertan {
  grid-column: 2/3;
  grid-row: 6/7;
  -ms-grid-column: 2;
  -ms-grid-row: 7;
  -ms-grid-column-align: center;
  font-size: 13px;
  text-align: center;
  letter-spacing: 2px;
  line-height: 1.5;
  font-weight: 300;
  display: none;
}
.modszertan.show {
  display: block;
}
.right {
  height: 48px;
  animation: mover 2s infinite alternate;
}
@keyframes mover {
  0% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-10px);
  }
  100% {
    transform: translateX(-10px);
  }
}
@media screen and (max-width: 1000px) {
  .inner {
    grid-template-columns: 20px 1fr 20px;
    grid-template-rows: auto auto auto 80px auto auto auto;
    -ms-grid-columns: 20px 1fr 20px;
    -ms-grid-rows: auto auto auto 80px auto auto auto;
  }
  .credits {
    grid-column: 2/3;
    grid-row: 5/6;
    -ms-grid-column: 2;
    -ms-grid-row: 5;
  }
  .next {
    grid-column: 2/3;
    grid-row: 4/5;
    -ms-grid-column: 2;
    -ms-grid-row: 4;
  }
  .modszertanopener {
    grid-column: 2/3;
    grid-row: 6/7;
    -ms-grid-column: 2;
    -ms-grid-row: 7;
    margin-bottom: 10px;
  }
  .modszertan {
    grid-column: 2/3;
    grid-row: 7/8;
    -ms-grid-column: 2;
    -ms-grid-row: 8;
  }
}
</style>
